import { Component, Input, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { first } from 'rxjs';
import { DashboardKpiService } from '../../../services/dashboard-kpi.service';
import { SalesSummaryEntity, Timespan } from '../../../types';

@Component({
    selector: 'lib-last-vs-this-week-sales-amount-summary-card',
    templateUrl: './last-vs-this-week-sales-amount-summary-card.component.html',
    styleUrls: ['./last-vs-this-week-sales-amount-summary-card.component.scss'],
    standalone: false
})
export class LastVsThisWeekSalesAmountSummaryCardComponent implements OnInit {
  @Input()
  preConditions: any;

  salesAmountThisWeek = 0;
  salesAmountLastWeek = 0;
  loaded = false;

  constructor(protected dashboardKpiService: DashboardKpiService) {}

  ngOnInit() {
    const thisWeekSpan = this.dashboardKpiService.getDateFromTimespan(Timespan.Week);
    const lastWeekSpan = this.dashboardKpiService.getDateFromTimespan(Timespan.LastWeek);

    forkJoin({
      salesSummaryGroupsThisWeek: this.dashboardKpiService
        .getSalesSummary(SalesSummaryEntity.PRODUCT, thisWeekSpan.fromDate, null, this.preConditions)
        .pipe(first()),
      salesSummaryGroupsLastWeek: this.dashboardKpiService
        .getSalesSummary(SalesSummaryEntity.PRODUCT, lastWeekSpan.fromDate, lastWeekSpan.toDate, this.preConditions)
        .pipe(first())
    }).subscribe(({ salesSummaryGroupsThisWeek, salesSummaryGroupsLastWeek }) => {
      this.salesAmountThisWeek = salesSummaryGroupsThisWeek.reduce((acc, curr) => acc + curr.totalAmount, 0);
      this.salesAmountLastWeek = salesSummaryGroupsLastWeek.reduce((acc, curr) => acc + curr.totalAmount, 0);
      this.loaded = true;
    });
  }
}
